import axios from 'axios';

  // At build time, the constant value is replaced.
const apiClient = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL,
  //timeout: 10000,
});

// optional logs
apiClient.interceptors.request.use(
  (config) => {
    // console.log('Request: ', config);
    return config;
  },
  (error) => Promise.reject(error),
);

apiClient.interceptors.response.use(
  (response) => response,
  (error)   => Promise.reject(error),
);

export default apiClient;
